import type { ReactNode } from "react";
import { useNavigationType } from "react-router-dom";
import { RouteNavigationTypeContext } from "@/shared/hooks/useRouteNavigationType";

/**
 * Routes 밖(전환 래퍼)에서 읽은 실제 이동 종류를 라우트 엘리먼트 안으로 내려주는 브리지 (#461).
 * `<Routes location={location}>` 아래의 react-router `useNavigationType()` 은 늘 "POP" 이라 쓸 수 없고,
 * 라우트 안 화면은 `useRouteNavigationType()` 으로 이 값을 마운트 시점에 한 번 읽는다.
 * 이 파일은 src/app/router 라 useNavigationType 금지 lint 의 예외다.
 */
export const RouteNavigationTypeBridge = ({ children }: { children: ReactNode }) => {
  const navType = useNavigationType();
  return (
    <RouteNavigationTypeContext.Provider value={navType}>
      {children}
    </RouteNavigationTypeContext.Provider>
  );
};
